import axios from "axios";

const externalApi = process.env.VUE_APP_API_EXTERNAL_URL;
const apiUrl = process.env.VUE_APP_API_URL;
const claroFlexExtensionsApi = process.env.VUE_APP_API_FLEX_EXTENSIONS;
const flexBffApi = process.env.VUE_APP_API_FLEX_BFF_V2;
const apiChatUrl = process.env.VUE_APP_API_CHAT_TOKEN;
const apiRwMiddlewareV2Url = process.env.VUE_APP_API_URL_V2;

export const apiExternalUrl = axios.create({
  baseURL: externalApi,
  timeout: 10000,
});

export const apiClaroFlexExtensions = axios.create({
  baseURL: claroFlexExtensionsApi,
  timeout: 10000,
});

export const apiClaro = axios.create({
  baseURL: apiUrl,
  timeout: 10000,
});

export const apiChat = axios.create({
  baseURL: apiChatUrl,
  timeout: 10000,
});

export const apiRwMiddlewareV2 = axios.create({
  baseURL: apiRwMiddlewareV2Url,
  timeout: 10000,
});

export const apiFlexBffV2 = axios.create({
  baseURL: flexBffApi,
});
